import $ from 'jquery';
import 'slick-carousel';
import getLayout from './get-modal-layout';
import {getSiblings} from './utils';
import Modal from './modal';

const classNames = {
  flat: {
    active: `modal-floors__flat-plan--active`
  }
};

class ModalFlatPlan extends Modal {
  constructor() {
    super();
    this.toggle = this.page.querySelectorAll(`.js-modal-flat`);
    this.plans = [];
    this.container = null;
    this.lang = document.querySelector(`body`).dataset.lang;
  }

  init(floors) {
    super.createModal();
    this.plans = floors;
    this.createPlansWrap();
    this.bindHandlers();
  }

  toggleModal = (isModalShown) => {
    this.getActiveFloor(isModalShown);
    super._toggleModal(isModalShown);
  };

  getActiveFloor(isModalShown) {
    const activeFloor = this.page.querySelector(`.js-gallery-control.flat-page__info--active`).dataset.floor;
    const selectedFlat = this.container.querySelector(`.modal-floors__flat-plan[data-flat="${activeFloor}"]`);
    const flats = getSiblings(selectedFlat);

    flats.forEach(flat => flat.classList.remove(classNames.flat.active));
    selectedFlat.classList.toggle(classNames.flat.active, isModalShown);
  };

  createPlansWrap() {
    super.addLayout(getLayout(`flat-plan`));
    this.createFloorsItems();
  };

  createFloorsItems() {
    const wrap = this.page.querySelector(`#flat-plan-modal`);
    const list = document.createElement(`ul`);
    const items = this.renderPlansLayout(this.plans);

    list.className = `modal-floors__slider modal-slider`;
    list.innerHTML = items;
    this.container = list;
    wrap.appendChild(list);
  };

  renderPlansLayout = () => {
    let lang_plan = `flat_plan_${this.lang}`;

    const renderPlan = data => {
      let plan = data[lang_plan],
          number = data.floor_number;

      if (!plan) {
        lang_plan = `flat_plan_ru`;
        plan = data[lang_plan];
      };

      return `<div class="modal-floors__flat-plan" data-flat="${number}">
                <img src="${plan}" alt="Планировка квартиры">
              </div>`
    };

    return this.plans.map(renderPlan).join(``);
  };

  bindHandlers() {
    if (this.toggle) {
      this.toggle.forEach((item) => {
        item.addEventListener(`click`, (e) => {
          e.preventDefault();
          this.toggleModal(true);
        });
      });
    }
  }
}

const modalFlatPlan = new ModalFlatPlan();

export default modalFlatPlan;
